module.exports = __webpack_public_path__ + "img/islington_roof_ext_b2.1ce1da11.jpg";